import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import VueHtmlToPaper from 'vue-html-to-paper';
import moment from 'moment'


//let basePath= 'https://invoicesystem.xyz';
let basePath = window.location.origin;
//let basePath= 'http://localhost:8080/';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    `${basePath}/printinv.css`
  ]
}

Vue.use(VueHtmlToPaper, options);
Vue.prototype.moment = moment
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  components: { App },
  vuetify,
  router,
  store,
  template: '<App/>'
}).$mount('#app')
